import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CommentsSection from './components/CommentsSection';
import RankingSection from './components/RankingSection';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import MediaSection from './components/MediaSection';
import FaqSection from './components/FaqSection';
import FeaturesSection from './components/FeaturesSection';
import TopicsSection from './components/TopicsSection';
import ContactSection from './components/ContactSection';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import CardsSection from './components/CardsSection';
import AboutSection from './components/AboutSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <CommentsSection />
        <RankingSection />
        <CarouselSection />
        <UpdatesSection />
        <MediaSection />
        <FaqSection />
        <FeaturesSection />
        <TopicsSection />
        <ContactSection />
        <AppSection />
        <IndexSection />
        <CardsSection />
        <AboutSection />
      </main>
      <Footer />
    </>
  );
}